import { jsPDF } from "jspdf";
import QRCode from "qrcode";

// Gera um PDF com etiquetas de patrimônio (2 colunas), cada uma com QR Code.
export async function gerarEtiquetasPatrimonio({ empresa, itens }) {
  const doc = new jsPDF();
  const labelW = 90, labelH = 48, marginX = 12, marginY = 14, gapX = 6, gapY = 5;
  let x = marginX, y = marginY, col = 0;
  const nomeEmp = (empresa?.nome || "Casa de Repouso São Jorge").slice(0, 30);

  for (const item of itens) {
    const origin = (typeof window !== "undefined" && window.location) ? window.location.origin : "";
    const payload = `${origin}/inventario/${item.id}`;
    let qr = null;
    try { qr = await QRCode.toDataURL(payload, { margin: 1, width: 200 }); } catch (e) { /* ignore */ }

    doc.setDrawColor(203, 213, 225);
    doc.roundedRect(x, y, labelW, labelH, 2, 2);
    if (qr) doc.addImage(qr, "PNG", x + 3, y + 4, 38, 38);

    const tx = x + 45;
    doc.setTextColor(37, 99, 235); doc.setFont("helvetica", "bold"); doc.setFontSize(8.5);
    doc.text(nomeEmp, tx, y + 8);
    doc.setTextColor(30, 41, 59); doc.setFontSize(10);
    doc.text(doc.splitTextToSize(item.nome || "-", 42), tx, y + 15);
    doc.setFont("helvetica", "normal"); doc.setFontSize(8); doc.setTextColor(71, 85, 105);
    doc.text(`Patrimônio: ${item.patrimonio || "-"}`, tx, y + 29);
    doc.text(`Local: ${(item.localizacao || "-").slice(0, 26)}`, tx, y + 34);
    doc.text(`Categoria: ${item.categoria || "-"}`, tx, y + 39);

    col += 1;
    if (col >= 2) { col = 0; x = marginX; y += labelH + gapY; }
    else { x += labelW + gapX; }
    if (y + labelH > 285) { doc.addPage(); x = marginX; y = marginY; col = 0; }
  }
  doc.save(`etiquetas-patrimonio-${new Date().toISOString().slice(0, 10)}.pdf`);
}
